import { APICore } from './apiCore';

const api = new APICore();

function assetList(): any {
    const baseUrl = '/assets';
    return api.getWithoutQuery(`${baseUrl}`, { headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}


function assetShow(params: any): any {
    const baseUrl = '/assets/' + params;
    return api.getWithoutQuery(`${baseUrl}`, { headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}

function assetFilter(params: any): any {
    const baseUrl = '/assets';
    console.log(baseUrl)
    return api.get(`${baseUrl}`, params,{ headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}

export { assetList, assetShow, assetFilter };